import React from "react";
import { CarouselInjectedProps, WithStore } from "pure-react-carousel";

interface CarouselWatcherProps {
  windowWidth: number;
}

class CarouselWatcher extends React.Component<
  CarouselWatcherProps & CarouselInjectedProps
> {
  componentDidUpdate(prevProps) {
    if (this.props.carouselStore !== prevProps.carouselStore) {
      const state = this.props.carouselStore.getStoreState();
      const maxAllowedSlide = state.totalSlides - state.visibleSlides;
      if (state.currentSlide > maxAllowedSlide) {
        this.props.carouselStore.setStoreState({
          currentSlide: maxAllowedSlide,
        });
      }
    }
  }
  render() {
    return <></>;
  }
}

export const CarouselWatcherDecorated =
  WithStore<CarouselWatcherProps>(CarouselWatcher);
